import React, { useEffect, useState } from 'react';
import axios from 'axios';
import RegionHeader from './RegionHeader';
import Error from './Error';

function ResvStation(props) {
	const [ stationData, setStationData ] = useState(null);
	const [ regionError, setRegionError ] = useState(false);

    const resvTitle = "Location of Lakes and Impoundments";
    const buttontext = "Map View";
    const buttonValue = "liregion";
    const ptDataFileName = (props.match ? ".." : ".") + "/data/station_li_coor.json";

   const droughtarea = [
        "Western",
        "Connecticut River",
        "Central",
        "Northeast",
        "Southeast",
        "Cape Cod",
    ];

    const getTownInfo = () => {
		axios.get(ptDataFileName)
		.then(results => {
			setStationData(results.data);
		})
		.catch(err => {
			console.log("Station Data Error: " + err);
		});
	}

    useEffect(() => {
        getTownInfo();
        setRegionError(false);
		// eslint-disable-next-line
	}, [])

	return (
        <>
        	<RegionHeader
				title={"Lakes/Impoundments"}
				buttontext={buttontext}
				buttonValue={buttonValue}
				handleButtonClick={props.handleButtonClick}
			/>
            
            {stationData &&
                <div style={{overflowX:"auto"}}>
                    <table className="pcpnTable-container">
                        <caption>  
                            {resvTitle}<br />
                        </caption>      
                        <thead>
                            <tr>
                                <th scope="col">Region</th>
                                <th scope="col">Town</th>
                            </tr>
                        </thead>
                        <tbody className="stnTable-container">
                            {droughtarea.map((rd, i) => (                           
                                <React.Fragment key={"f"+i}>
                                    {Object.keys(stationData[rd]).map((stn, j) => (
                                        <tr key={i+"stn"+j}>
                                            <td>{rd.replace("Connecticut River","CTRV")}</td>
                                            <td>{stationData[rd][stn]["name"]}</td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
        }

            {regionError &&
				<>
					<Error />
				</>
			}
        </>
	);
}

export default ResvStation